

if (!customElements.get("tab-switcher")) {
  customElements.define(
    "tab-switcher",
    class TabSwitcher extends HTMLElement {
      connectedCallback() {
        this.buttons = [...this.querySelectorAll("[data-tab-target]")];
        this.panels = [...this.querySelectorAll("[data-tab-panel]")];
        this.buttons.forEach((btn) =>
          btn.addEventListener("click", () =>
            this.select(btn.dataset.tabTarget)
          )
        );
        this.select(this.dataset.default || this.buttons[0]?.dataset.tabTarget);
      }

      select(name) {
        if (!name) return;
        this.buttons.forEach((btn) => {
          const active = btn.dataset.tabTarget === name;
          btn.classList.toggle("is-active", active);
          btn.setAttribute("aria-selected", active ? "true" : "false");
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.tabPanel !== name;
        });
      }
    }
  );
}
